import { render, staticRenderFns } from "./DataTableGolden.vue?vue&type=template&id=1034659a&scoped=true"
import script from "./DataTableGolden.vue?vue&type=script&lang=js"
export * from "./DataTableGolden.vue?vue&type=script&lang=js"
import style0 from "./DataTableGolden.vue?vue&type=style&index=0&id=1034659a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1034659a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1034659a')) {
      api.createRecord('1034659a', component.options)
    } else {
      api.reload('1034659a', component.options)
    }
    module.hot.accept("./DataTableGolden.vue?vue&type=template&id=1034659a&scoped=true", function () {
      api.rerender('1034659a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/DataTableGolden.vue"
export default component.exports